// extracted by mini-css-extract-plugin
export default {"description":"FeatureInfo_description__pAyeS"};